<section class="d-flex flex-column justify-content-between vh-100">
  <app-navbar></app-navbar>
  <main>
    <section class="banner-area py-5" id="banner-module">
      <div class="container">
        <div class="row align-items-center g-5">
          <!-- Left Text Content -->
          <div class="col-lg-6">
            <div class="pe-lg-5">
              <h1 class="fw-bold mb-4">
                Revolutionize Vehicle
                <span class="text-gradient">Sales</span> &
                <span class="text-gradient">Inspections</span> with Autozaki
              </h1>
              <p class="mb-5">
                At Autozaki, we specialize in transforming the automotive industry by providing
                cutting-edge solutions for car-related services. We offer smart vehicle inspections
                with VIA, streamline car sales and auctions through CEN, and provide a robust web
                portal for inventory and customer management, all designed to enhance efficiency and
                transparency in the car market.
              </p>

              <!-- Stats Row -->
              <div class="row text-center">
                <div class="col-4">
                  <h2 class="fw-bold mb-1">
                    <span class="text-gradient">500+</span>
                  </h2>
                  <p class="mb-0 small text-muted">Cars Inspected Daily</p>
                </div>
                <div class="col-4">
                  <h2 class="fw-bold text-gradient mb-1">100+</h2>
                  <p class="mb-0 small text-muted">Dealer Networks</p>
                </div>
                <div class="col-4">
                  <h2 class="fw-bold text-gradient mb-1">10+</h2>
                  <p class="mb-0 small text-muted">Countries Operated</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Right Image Content -->
          <div class="col-lg-6 text-center">
            <img
              src="/assets/images/dashboard_car.jpg"
              alt="Dashboard"
              class="img-fluid shadow-lg w-100"
              style="max-height: 500px; object-fit: cover; border-radius: 1rem"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="section-space pt-0" id="core-module">
      <div class="container">
        <h2 class="text-center mb-4">Core Modules</h2>
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="card p-4 shadow-sm">
              <img src="/assets/images/car_Inspection.jpg" alt="VIA" class="img-fluid mb-3" />
              <h5>VIA – Vehicle Inspection & Assessment</h5>
              <p>
                VIA is our smart digital toolkit designed to transform how vehicles are inspected,
                evaluated, and prepared for resale. Automates vehicle inspections with structured
                checklists, generates professional, data-rich reports in minutes, and tracks repair
                and maintenance in real time. Builds trust with customers by ensuring transparent
                assessments and cuts down manual errors and reduces inspection time by up to 40%.
              </p>
            </div>
          </div>
          <div class="col-md-6 mb-4">
            <div class="card p-4 shadow-sm">
              <img src="/assets/images/centarl_image.jpg" alt="CEN" class="img-fluid mb-3" />
              <h5>CEN – Central Engine Network</h5>
              <p>
                The Central Engine Network System is the operational backbone of your automotive
                business. It unifies and digitizes all your critical workflows, including yard
                management, inventory oversight, job order processing, auctions setup & tracking,
                customer walk-ins, and real-time analytics. With CEN, businesses get end-to-end
                visibility, automation, and smarter decision-making leading to faster operations and
                higher profitability.
              </p>
            </div>
          </div>
          <div class="col-md-12">
            <div class="card p-4 shadow-sm">
              <img src="/assets/images/car_admin.jpg" alt="Web Portal" class="img-fluid mb-3" />
              <h4>Web Portal + Admin Panel</h4>
              <p>
                Our web portal is a complete online platform designed to manage and sell both new
                and used vehicles with ease. Key features include intuitive vehicle listing and
                sales interface, fully integrated auction system, retail-ready features for
                trade-ins, pricing, and reporting, and mobile-friendly for a smooth customer
                experience.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-space bg-light pt-0" id="why-choose">
      <div class="container">
        <h2 class="text-center mb-4">Why Choose VIA & CEN?</h2>
        <div class="row">
          <div class="col-md-4">
            <div class="card feature-card text-center p-4">
              <img
                src="/assets/images/data-analytics.jpg"
                alt="Data Analytics"
                class="mb-3 img-fluid"
              />
              <h5>Data-Driven Decisions</h5>
              <p>
                Start with easy vehicle registration, capturing all essential details in one place.
                Conduct thorough inspections and assessments using structured checklists and visual
                uploads.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card feature-card text-center p-4">
              <img
                src="/assets/images/one-platform.jpg"
                alt="Auction System"
                class="mb-3 img-fluid"
              />
              <h5>All-in-One Auction System</h5>
              <p>
                Acts as the digital backbone of your operations—centralizing all key functions and
                automating workflows across yard activity resource, vehicle tracking, inventory,
                auctions, and more.
              </p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card feature-card text-center p-4">
              <img src="/assets/images/support.jpg" alt="Real-Time Tracking" class="mb-3" />
              <h5>Real-Time Repair & Evaluation</h5>
              <p>
                Replaces manual tasks with real-time visibility and smart data flow, offering
                modular, flexible tools that adapt to your evolving business needs.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-space pt-0">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-center">The Full Autozaki-Tech Stack Demystified</h2>
            <p class="text-center mb-5">
              A powerful suite designed to eliminate information asymmetry across vehicle
              management, sales, and service channels, tailored for the automotive industry.
            </p>
            <div
              class="mt-4 p-5 card shadow border channel-tech-jumbo element-radius position-sticky tech-jumbo1"
            >
              <div class="row px-4 justify-content-between align-items-center">
                <div class="col-md-4">
                  <img src="/assets/images/car_Inspection.jpg" alt="VIA image" class="img-fluid" />
                </div>
                <div class="col-md-7">
                  <h5 class="position-relative pb-3 mb-3">VIA – Vehicle Inspection & Assessment</h5>
                  <p>
                    Autozaki’s VIA is a smart digital toolkit that automates vehicle inspections
                    with structured checklists, generates data-rich reports in minutes, and tracks
                    repairs in real-time, reducing inspection time by up to 40% and enhancing
                    transparency.
                  </p>
                  <button type="button" class="btn btn-outline-primary px-4 d-none d-md-block">
                    Know More
                  </button>
                </div>
              </div>
            </div>
            <div
              class="mt-4 p-5 card shadow border channel-tech-jumbo element-radius position-sticky tech-jumbo2"
            >
              <div class="row px-4 justify-content-between align-items-center">
                <div class="col-md-4">
                  <img src="/assets/images/centarl_image.jpg" alt="CEN image" class="img-fluid" />
                </div>
                <div class="col-md-7">
                  <h5 class="position-relative pb-3 mb-3">CEN – Central Engine Network</h5>
                  <p>
                    Autozaki’s CEN serves as the operational backbone, unifying yard management,
                    inventory oversight, job order processing, auctions, and real-time analytics,
                    delivering end-to-end visibility and automation for higher profitability.
                  </p>
                  <button type="button" class="btn btn-outline-primary px-4 d-none d-md-block">
                    Know More
                  </button>
                </div>
              </div>
            </div>
            <div
              class="mt-4 p-5 card shadow border channel-tech-jumbo element-radius position-sticky tech-jumbo3"
            >
              <div class="row px-4 justify-content-between align-items-center">
                <div class="col-md-4">
                  <img
                    src="/assets/images/car_admin.jpg"
                    alt="Web Portal image"
                    class="img-fluid"
                  />
                </div>
                <div class="col-md-7">
                  <h5 class="position-relative pb-3 mb-3">Web Portal + Admin Panel</h5>
                  <p>
                    Autozaki’s Web Portal offers a complete online platform for managing vehicle
                    sales and auctions, featuring an intuitive interface, real-time reporting, and
                    mobile-friendly access for seamless customer experiences.
                  </p>
                  <button type="button" class="btn btn-outline-primary px-4 d-none d-md-block">
                    Know More
                  </button>
                </div>
              </div>
            </div>
            <div
              class="mt-4 p-5 card shadow border channel-tech-jumbo element-radius position-sticky tech-jumbo4"
            >
              <div class="row px-4 justify-content-between align-items-center">
                <div class="col-md-4">
                  <img
                    src="/assets/images/retails.webp"
                    alt="Retail Execution image"
                    class="img-fluid"
                  />
                </div>
                <div class="col-md-7">
                  <h5 class="position-relative pb-3 mb-3">Retail Execution Management</h5>
                  <p>
                    Autozaki’s Retail Execution Management provides end-to-end solutions for
                    transparent and effective retail campaigns, maximizing brand visibility in the
                    automotive sector.
                  </p>
                  <button type="button" class="btn btn-outline-primary px-4 d-none d-md-block">
                    Know More
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-space pt-0" id="testimonials">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-center mb-5">Customers Speak</h2>
            <div
              class="carousel-card px-5 py-4 card border-0 element-radius testimonial-slide position-relative"
            >
              <div class="card-body">
                <!-- carousel -->
                <div id="carouselExample" class="carousel slide" data-bs-wrap="false">
                  <!-- Indicators -->
                  <div class="carousel-indicators">
                    <button
                      type="button"
                      data-bs-target="#carouselExample"
                      data-bs-slide-to="0"
                      class="active"
                      aria-current="true"
                      aria-label="Slide 1"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExample"
                      data-bs-slide-to="1"
                      aria-label="Slide 2"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExample"
                      data-bs-slide-to="2"
                      aria-label="Slide 3"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExample"
                      data-bs-slide-to="3"
                      aria-label="Slide 4"
                    ></button>
                    <button
                      type="button"
                      data-bs-target="#carouselExample"
                      data-bs-slide-to="4"
                      aria-label="Slide 5"
                    ></button>
                  </div>

                  <!-- Slides -->
                  <div class="carousel-inner">
                    <div class="carousel-item active">
                      <div class="d-block w-100 text-left">
                        <h5>Afzal Khan</h5>
                        <p>Operations Manager, Gulf Auto Traders</p>
                        <p>
                          “Autozaki’s VIA has transformed our inspection process, providing clear,
                          actionable insights that save us time and boost trust with our clients.”
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="d-block w-100 text-left">
                        <h5>Sarah Khan</h5>
                        <p>Inventory Head, Horizon Motors</p>
                        <p>
                          With Autozaki’s CEN, we’ve streamlined our inventory and auction
                          processes, achieving a 30% increase in operational efficiency.
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="d-block w-100 text-left">
                        <h5>Rajesh Patel</h5>
                        <p>CEO, Pinnacle Auto Group</p>
                        <p>
                          The Autozaki platform’s real-time reporting and easy onboarding have
                          revolutionized how we manage vehicle sales across multiple locations.
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="d-block w-100 text-left">
                        <h5>Aisha Rahman</h5>
                        <p>Sales Director, Elite Cars</p>
                        <p>
                          Autozaki’s support team is exceptional, helping us integrate VIA and CEN
                          seamlessly into our workflow.
                        </p>
                      </div>
                    </div>
                    <div class="carousel-item">
                      <div class="d-block w-100 text-left">
                        <h5>Vikram Singh</h5>
                        <p>Operations Lead, Auto Solutions</p>
                        <p>
                          Thanks to Autozaki, our auction turnaround time has halved, thanks to the
                          intuitive web portal and analytics.
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- Controls -->
                  <button
                    class="carousel-control-prev"
                    type="button"
                    data-bs-target="#carouselExample"
                    data-bs-slide="prev"
                    disabled
                  >
                    <span aria-hidden="true">&lsaquo;</span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button
                    class="carousel-control-next"
                    type="button"
                    data-bs-target="#carouselExample"
                    data-bs-slide="next"
                  >
                    <span aria-hidden="true">&rsaquo;</span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
              <!-- <div class="shape position-absolute top-0 end-0">
                                <img src="{{ url('/assets/images/testimonial-shape.svg') }}" alt="" class="img-fluid">
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="success-area section-space pt-0 pb-5" id="story">
      <div class="container">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-12">
            <h2 class="mb-3">Success Story</h2>
            <p class="mb-4">
              Learn how VIA & CEN helped 100+ businesses digitize inspections, launch auction
              portals, and boost sales — all in a few days with Autozaki.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="fequantly-asked section-space pt-0" id="faq">
      <div class="container">
        <h2 class="text-center mb-5">Frequently Asked Questions</h2>
        <div class="row justify-content-center">
          <div class="col-md-9">
            <div class="accordion" id="accordionExample">
              <div class="accordion-item position-relative">
                <div class="left-border-arrow position-absolute"></div>
                <div class="accordion-item-border position-absolute start-0 top-0"></div>
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button fw-bold shadow-none"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    What is VIA?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body px-5 py-0">
                    <p>
                      <strong>VIA</strong> is our smart digital toolkit designed to transform how
                      vehicles are inspected, evaluated, and prepared for resale within Autozaki.
                    </p>
                    <ul>
                      <li>Automates vehicle inspections with structured checklists.</li>
                      <li>Generates professional, data-rich reports in minutes.</li>
                      <li>Track repair and maintenance in real time.</li>
                      <li>Builds trust with customers by ensuring transparent assessments.</li>
                      <li>Cuts down manual errors and reduces inspection time by up to 40%.</li>
                    </ul>
                    <p>
                      With VIA, every vehicle can be assessed fairly, maintained properly, and
                      priced accurately.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item position-relative">
                <div class="left-border-arrow position-absolute"></div>
                <div class="accordion-item-border position-absolute start-0 top-0"></div>
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed fw-bold shadow-none"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    What is CEN?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body px-5 py-0">
                    <p>
                      The Central Engine Network System is the operational backbone of your
                      automotive business within Autozaki.
                    </p>
                    <ul>
                      <li>It unifies and digitizes all your critical workflows.</li>
                      <li>Yard management.</li>
                      <li>Inventory oversight.</li>
                      <li>Job order processing.</li>
                      <li>Auctions setup & tracking.</li>
                      <li>Customer walk-ins.</li>
                      <li>Real-time analytics.</li>
                    </ul>
                    <p>
                      With CEN, businesses get end-to-end visibility, automation, and smarter
                      decision-making leading to faster operations and higher profitability.
                    </p>
                  </div>
                </div>
              </div>
              <div class="accordion-item position-relative">
                <div class="left-border-arrow position-absolute"></div>
                <div class="accordion-item-border position-absolute start-0 top-0"></div>
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed fw-bold shadow-none"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    How fast can I onboard?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body px-5 py-0">
                    <p>
                      Our onboarding process is fast and reliable, we just need a day or two to put
                      your entire business online with Autozaki.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section-space pt-0">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-center mb-5">Key Features of The Autozaki-Tech Stack</h2>
          </div>
        </div>
        <div class="row key-feature-grid">
          <div class="col-md-4">
            <div class="card feature-card shadow border-0 element-radius overflow-hidden">
              <div class="card-header p-0 border-0 bg-transparent">
                <img src="/assets/images/data-analytics.svg" alt="" />
              </div>
              <div class="card-body pb-2">
                <div class="feature-icon"></div>
                <h6>Data Made Simple. Decisions Made Smart.</h6>
                <p>
                  Leverage Autozaki’s analytics to monitor vehicle inspections and sales data,
                  driving informed decisions with ease.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card feature-card shadow border-0 element-radius overflow-hidden">
              <div class="card-header p-0 border-0 bg-transparent">
                <img src="/assets/images/one-platform.svg" alt="" class="dashboard-img" />
              </div>
              <div class="card-body pb-2">
                <div class="feature-icon"></div>
                <h6>One Platform. More Time to Sell.</h6>
                <p>
                  Autozaki’s unified platform simplifies inventory, auctions, and sales management,
                  saving time for your team.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card feature-card shadow border-0 element-radius overflow-hidden">
              <div class="card-header p-0 border-0 bg-transparent">
                <img src="/assets/images/support.svg" alt="" class="trophy-img" />
              </div>
              <div class="card-body pb-2">
                <div class="feature-icon"></div>
                <h6>Top-Notch Support. Zero Worries.</h6>
                <p>
                  Autozaki’s dedicated support ensures your success, providing tailored assistance
                  for all your automotive needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer></app-footer>
</section>
